import SessionManager from './sessionManager';

const parseAttributes = (attributes) => {
    try {
        return attributes.map(val => (typeof val === 'string' ? JSON.parse(val) : val)).flat().filter(Boolean)
    } catch {
        return []
    }
}

export const getStoredPermissions = () => {
    try {
        let stored = SessionManager.getSession('permission')
        if (typeof stored === 'string') stored = JSON.parse(stored)
        return Array.isArray(stored) ? stored : []
    } catch {
        return []
    }
}

export const getEffectivePermissions = (attributes) =>
    Array.isArray(attributes) ? parseAttributes(attributes) : getStoredPermissions()

const normalize = (value) => String(value ?? '').trim().replace(/\s+/g, ' ').toLowerCase()

export const hasAction = (permissions, actions) => {
    const required = [].concat(actions || []).map(normalize).filter(Boolean)
    if (!required.length || !Array.isArray(permissions)) return false
    return permissions.some(item => required.includes(normalize(item?.sub_action_name)))
}

export const hasPermission = (permissions, routes) => {
    const required = [].concat(routes || []).filter(Boolean)
    if (!required.length || !Array.isArray(permissions)) return false
    return permissions.some(item => required.includes(item?.route))
}
